<template>
  <div class="form-group row">
    <div class="container mt-1">
      <alert-comp :msg="msgAlert" />
    </div>
    <label class="col-sm-2 text-sm-left">Motivo da Devolução:</label>
    <textarea class="form-control col-sm-10 mb-3" rows="5" v-model="motivoDevolucao"/>
      <div class="row btnAcoes">
        <button class="btn btn-outline-success" @click.prevent="concluir"> Concluir </button>
      </div>
  </div>
</template>

<script>
import DestinatarioService from '@/services/DestinatarioService'
import alertComp from '@/components/alert/AlertComp'

export default {
  name: 'devolver',

  components: {
    alertComp
  },

  props: {
    closeModalEvent: { required: true, type: Function }
  },

  data () {
    return {
      motivoDevolucao: '',
      msgAlert: {
        texto: '',
        type: ''
      }
    }
  },

  created () {
    this.service = new DestinatarioService()
  },

  methods: {
    concluir () {
      const dadosSessao = this.$store.getters.getDadosSessao
      const processos = this.$store.getters.getDataTableChecked

      if (this.motivoDevolucao) {
        for (var index in processos) {
          var processo = processos[index]

          var destinatario = processo.data.atributos.origem

          this.service.devolver(processo, this.motivoDevolucao, dadosSessao.sessao, destinatario).then((data) => {
            this.closeModalEvent()
          })
        }
      } else {
        this.msgAlert.texto = 'É obrigatório informar o motivo da devolução.'
        this.msgAlert.type = 'warning'
      }
    }
  }
}
</script>
